/**
 * AuthGuard
 *
 * Wraps protected routes. Shows loading spinner during auth check,
 * redirects to login if not authenticated.
 */

import { useAuth } from '@/lib/auth.js';
import { LoginPage } from '@/features/auth/LoginPage.js';

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-blue-600" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
